'use client';

import { PartnerLoginLayout } from 'app-components/common/layout/PartnerLoginLayout';
import PartnerSignInForm from 'app/(main)/accounts/partners/sign-in/PartnerSignInForm';

export default function AccountsSignInCpPage() {
  return (
    <>
      <title>파트너 로그인 | 디리토</title>
      <PartnerLoginLayout title="로그인">
        <PartnerSignInForm />
      </PartnerLoginLayout>
    </>
  );
}
